<div class="ui-scope-toggle" role="radiogroup" [attr.aria-label]="ariaLabel()">
  @for (option of viewOptions(); track option.value) {
    <button
      class="ui-scope-toggle-option"
      type="button"
      role="radio"
      [class.ui-scope-toggle-option-active]="option.selected"
      [attr.aria-checked]="option.selected"
      [attr.aria-label]="option.label"
      [disabled]="disabled() || option.disabled"
      (click)="handleOptionSelected(option, $event)"
    >
      <span class="ui-scope-toggle-icon" aria-hidden="true">
        @switch (option.value) {
          @case ('me') {
            <svg viewBox="0 0 24 24" focusable="false">
              <circle cx="12" cy="8" r="4" />
              <path d="M5 21a7 7 0 0 1 14 0" />
            </svg>
          }
          @case ('home') {
            <svg viewBox="0 0 24 24" focusable="false">
              <path d="m3 11 9-8 9 8" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
          }
          @case ('all') {
            <svg viewBox="0 0 24 24" focusable="false">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.9" />
              <path d="M16 3.1a4 4 0 0 1 0 7.8" />
            </svg>
          }
          @default {
            {{ option.iconLabel }}
          }
        }
      </span>
      <span class="ui-scope-toggle-copy">
        <span class="ui-scope-toggle-label">{{ option.label }}</span>
        @if (option.count !== null) {
          <span class="ui-scope-toggle-count">{{ option.count }}</span>
        }
      </span>
    </button>
  }
</div>
